/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useRef } from "react";

import Button from "components/Button";
import ErrorBar from "components/ErrorBar";
import Greeting from "components/Greeting";
import Label from "components/Label";
import Autocomplete from "react-google-autocomplete";
import { AiOutlineClear as ClearIcon } from "react-icons/ai";
import { FaMapMarkerAlt as MapIcon } from "react-icons/fa";

import styles from "./styles.module.scss";

type Props = {
  onChange(place: any): void;
  value: any;
  placeholder?: string;
  error?: string;
  id?: string;
  disabled?: boolean;
};

const GoogleMapsAutocomplete: FC<Props> = ({
  onChange,
  value,
  placeholder,
  error,
  id,
  disabled = false,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.container}>
      <div className={styles.autocompleteWrapper}>
        <Autocomplete
          ref={inputRef}
          id={id}
          placeholder={placeholder}
          options={{ types: "address" }}
          className={styles.autocomplete}
          apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          onPlaceSelected={(place) => {
            onChange(place);
          }}
        />
        <Button
          disabled={disabled}
          variant="text"
          onClick={() => {
            onChange(undefined);
            if (inputRef.current) inputRef.current.value = "";
          }}
          Icon={<ClearIcon className={styles.icon} />}
        />
      </div>
      <Greeting
        className={styles.detail}
        duration={0.3}
        unmountOn={!value?.formatted_address}
      >
        <MapIcon className={styles.mapIcon} />
        <Label color="primary">{value?.formatted_address}</Label>
      </Greeting>
      <ErrorBar id={id} className={styles.error} error={error} />
    </div>
  );
};

GoogleMapsAutocomplete.defaultProps = {
  placeholder: undefined,
  error: undefined,
  id: undefined,
  disabled: false,
};

export default GoogleMapsAutocomplete;
